module.exports = __webpack_public_path__ + "static/media/2030109000.db583835.jpg";